import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaHome, FaWrench, FaCalendar, FaCog, FaBell, FaUser, FaSignInAlt, FaUserPlus } from 'react-icons/fa';
import { useState } from 'react';
import Logo from './img1.png'

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isAdmin = localStorage.getItem('isAdmin') === 'true';
  const isLoggedIn = localStorage.getItem('user') !== null; // Add this to check login status

  const navItems = [
    { path: '/', icon: <FaHome />, label: 'Home' },
    { path: '/repair-centers', icon: <FaWrench />, label: 'Repair Centers' },
    { path: '/appointments', icon: <FaCalendar />, label: 'Appointments' },
    { path: '/spare-parts', icon: <FaCog />, label: 'Spare Parts' },
    { path: '/notifications', icon: <FaBell />, label: 'Notifications' },
  ];

  const handleAdminLogin = () => {
    navigate('/admin/login');
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('isAdmin');
    navigate('/login');
  };

  return (
    <nav className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src={Logo} 
              alt="SmartRepair Logo"
              className="h-20 w-auto md:h-12 hover:scale-105 transition-transform" // Increased size, added responsive height and hover effect
            />
            <span className="font-bold text-xl">SmartRepair</span>
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-2 hover:text-blue-200 transition-colors ${
                  location.pathname === item.path ? 'text-blue-200' : ''
                }`}
              >
                {item.icon}
                <span>{item.label}</span>
              </Link>
            ))}

            {/* Auth Buttons - Desktop */}
            <div className="flex items-center space-x-4">
              {!isLoggedIn ? (
                <>
                  <Link
                    to="/login"
                    className="flex items-center space-x-2 hover:text-blue-200 transition-colors"
                  >
                    <FaSignInAlt />
                    <span>Login</span>
                  </Link>
                  <Link
                    to="/register"
                    className="flex items-center space-x-2 bg-white text-blue-600 px-4 py-2 rounded-lg hover:bg-blue-50 transition-colors"
                  >
                    <FaUserPlus />
                    <span>Register</span>
                  </Link>
                </>
              ) : (
                <>
                  {isAdmin && (
                    <Link
                      to="/admin/dashboard"
                      className="flex items-center space-x-2 hover:text-blue-200"
                    >
                      <FaUser />
                      <span>Admin Dashboard</span>
                    </Link>
                  )}
                  <button
                    onClick={handleLogout}
                    className="flex items-center space-x-2 bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition-colors"
                  >
                    <FaSignInAlt />
                    <span>Logout</span>
                  </button>
                </>
              )}
            </div>
          </div>
          
          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-white hover:text-blue-200"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMobileMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-16 left-0 right-0 bg-blue-600 shadow-lg z-50">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-2 px-4 py-3 hover:bg-blue-700 ${
                  location.pathname === item.path ? 'bg-blue-700' : ''
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.icon}
                <span>{item.label}</span>
              </Link>
            ))}

            {/* Auth Buttons - Mobile */}
            {!isLoggedIn ? (
              <>
                <Link
                  to="/login"
                  className="flex items-center space-x-2 px-4 py-3 hover:bg-blue-700"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <FaSignInAlt />
                  <span>Login</span>
                </Link>
                <Link
                  to="/register"
                  className="flex items-center space-x-2 px-4 py-3 bg-blue-700 hover:bg-blue-800"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <FaUserPlus />
                  <span>Register</span>
                </Link>
              </>
            ) : (
              <>
                {isAdmin && (
                  <Link
                    to="/admin/dashboard"
                    className="flex items-center space-x-2 px-4 py-3 hover:bg-blue-700"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <FaUser />
                    <span>Admin Dashboard</span>
                  </Link>
                )}
                <button
                  onClick={() => {
                    handleLogout();
                    setIsMobileMenuOpen(false);
                  }}
                  className="flex items-center space-x-2 px-4 py-3 w-full text-left bg-red-500 hover:bg-red-600"
                >
                  <FaSignInAlt />
                  <span>Logout</span>
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;